import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle, faClock, faExclamationCircle } from "@fortawesome/pro-solid-svg-icons";

import { COMMUNICATION_CHANNELS, COMMUNICATION_RECEIVER_STATUSES } from "../../../../../../util/communication_statuses";

import "./index.scss";

const getChannelName = (channel, t) => {
  switch (channel) {
    case COMMUNICATION_CHANNELS.EMAIL:
      return t("cc_email").message || "Email";
    case COMMUNICATION_CHANNELS.SMS:
      return t("cc_sms").message || "SMS";
    case COMMUNICATION_CHANNELS.WHATSAPP:
      return t("cc_whatsapp_message").message || "WhatsApp message";
    default:
      return "";
  }
};

const CommunicationReceiverAndChannel = ({ receiver, t }) => {
  const channel = getChannelName(receiver.channel, t);

  if (receiver.status === COMMUNICATION_RECEIVER_STATUSES.PENDING) {
    return (
      <span className="receiver-status receiver-status--pending">
        <FontAwesomeIcon icon={faClock} className="receiver-status-icon" />
        {channel} {t("cc_is_pending").message || "is pending"}
      </span>
    );
  }

  if (receiver.status === COMMUNICATION_RECEIVER_STATUSES.SUCCESS) {
    return (
      <span className="receiver-status receiver-status--success">
        <FontAwesomeIcon icon={faCheckCircle} className="receiver-status-icon" />
        {channel} {t("cc_is_sent").message || "is sent"}
      </span>
    );
  }

  return (
    <span className="receiver-status receiver-status--failed">
      <FontAwesomeIcon icon={faExclamationCircle} className="receiver-status-icon" />
      {channel} {t("cc_has_failed").message || "has failed"}
      {receiver.reason && <span className="receiver-status-reason">{`: ${receiver.reason}`}</span>}
    </span>
  );
};

export default CommunicationReceiverAndChannel;
